import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { AuthFacade, ResourcesService } from '@mitsubishi/core';
import { DatasheetFacade } from '@mitsubishi/project/data-access';
import { ConfigurationAlertsDialogComponent } from '@mitsubishi/project/shared';
import { PerformanceMessage } from '@mitsubishi/shared/data-access';
import { DialogService } from '@mitsubishi/ui/dialog';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-headless-table-wrapper',
  templateUrl: './headless-table-wrapper.component.html',
  styleUrls: ['./headless-table-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeadlessTableWrapperComponent extends FieldWrapper implements OnInit {
  canDebug = inject(AuthFacade).canDebug;

  selectedRow$ = this.datasheetFacade.selectedRow$;
  isEditing$ = this.datasheetFacade.isEditing$;

  isFirst;

  constructor(
    private datasheetFacade: DatasheetFacade,
    private serverResourceService: ResourcesService,
    private dialogService: DialogService
  ) {
    super();
  }

  ngOnInit() {
    this.isFirst = this.field?.parent?.fieldGroup?.findIndex(f => f.key === this.field.key) === 0;
  }

  setSelectedRow($event: MouseEvent, key?: any) {
    $event.stopPropagation();
    this.datasheetFacade.setSelectedRow(key);
  }

  showErrorMessages(errorsResource: number[]) {
    const errorMessages: PerformanceMessage[] = errorsResource.map((error: any) => {
      return {
        code: '',
        description: '',
        descriptionId: error.id,
        messageType: 2,
        parameters: [error.performanceValue, error.performanceUserValue],
      };
    });

    const data = {
      messages: errorMessages,
      title: this.serverResourceService.getTextResource('445235'),
    };
    this.dialogService.openDialog(ConfigurationAlertsDialogComponent, 'md', data);
  }
}
